var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61719 8.47266C1.61719 9.17196 1.89498 9.84262 2.38946 10.3371C2.88395 10.8316 3.5546 11.1094 4.25391 11.1094C4.95321 11.1094 5.62387 10.8316 6.11835 10.3371C6.61283 9.84262 6.89062 9.17196 6.89062 8.47266C6.89062 7.77335 6.61283 7.1027 6.11835 6.60821C5.62387 6.11373 4.95321 5.83594 4.25391 5.83594C3.5546 5.83594 2.88395 6.11373 2.38946 6.60821C1.89498 7.1027 1.61719 7.77335 1.61719 8.47266Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1094 4.78125C11.1094 5.48055 11.3872 6.15121 11.8817 6.64569C12.3761 7.14017 13.0468 7.41797 13.7461 7.41797C14.4454 7.41797 15.1161 7.14017 15.6105 6.64569C16.105 6.15121 16.3828 5.48055 16.3828 4.78125C16.3828 4.08195 16.105 3.41129 15.6105 2.91681C15.1161 2.42233 14.4454 2.14453 13.7461 2.14453C13.0468 2.14453 12.3761 2.42233 11.8817 2.91681C11.3872 3.41129 11.1094 4.08195 11.1094 4.78125Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1094 13.2188C11.1094 13.9181 11.3872 14.5887 11.8817 15.0832C12.3761 15.5777 13.0468 15.8555 13.7461 15.8555C14.4454 15.8555 15.1161 15.5777 15.6105 15.0832C16.105 14.5887 16.3828 13.9181 16.3828 13.2188C16.3828 12.5194 16.105 11.8488 15.6105 11.3543C15.1161 10.8598 14.4454 10.582 13.7461 10.582C13.0468 10.582 12.3761 10.8598 11.8817 11.3543C11.3872 11.8488 11.1094 12.5194 11.1094 13.2188Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71204 7.51691L11.288 5.7373",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61292 9.65234L11.3871 12.0395",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.a3171de63bd681a3be699640ed3506e7.svg";
export { ForwardRef as ReactComponent };